import { useMemo } from "react";

export const useIntesectionObserver = (callback: IntersectionObserverCallback) => {
  let observer = useMemo<IntersectionObserver | false>(() => {
    if ('IntersectionObserver' in window) {
      return new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          callback && callback(entries, observer);
        }
      }, { threshold: .9 })
    } else return false;
  }, [callback]);

  return observer;
}